// extracted by mini-css-extract-plugin
export var textInput = "_eb-0";